export default "__VITE_ASSET__TnxqrP01__"